module.exports = __webpack_public_path__ + "img/44Obama.7652dd6b.png";